export const dialogueSequenceStart = [
  {
    character: "",
    text: "Carrot and Broccoli arrive at a sunny picnic spot with a blanket and basket, tired from all that jumping and dodging candy!",
    imgLinkBroccoli: "",
    imgLinkCarrot: "",
  },
  {
    character: "broccoli",
    text: "Ahh… nothing beats a picnic on a perfect day like this!",
    imgLinkBroccoli: "broccoli1",
    imgLinkCarrot: "carrot2",
  },
  {
    character: "broccoli",
    text: "I brought the blanket! And... uh-oh... I think that's all I packed.",
    imgLinkBroccoli: "broccoli2",
    imgLinkCarrot: "carrot4",
  },
  {
    character: "carrot",
    text: "Wait, what about the food? I thought you said that you were going to get it.",
    imgLinkBroccoli: "broccoli3",
    imgLinkCarrot: "carrot1",
  },
  {
    character: "broccoli",
    text: "Oh no! I totally forgot! I got so excited about the picnic, I left the snacks at home!",
    imgLinkBroccoli: "broccoli1",
    imgLinkCarrot: "carrot4",
  },
  {
    character: "broccoli",
    text: "Maybe you could help make the food? I am not really the best around the kitchen. Sorry.",
    imgLinkBroccoli: "broccoli4",
    imgLinkCarrot: "carrot3",
  },
  {
    character: "carrot",
    text: "Seriously?",
    imgLinkBroccoli: "broccoli2",
    imgLinkCarrot: "carrot1",
  },
  {
    character: "carrot",
    text: "Okay fine. But next time, remember to bring the food!",
    imgLinkBroccoli: "broccoli1",
    imgLinkCarrot: "carrot2",
  },
  {
    character: "carrot",
    text: "Let's make something healthy and super yummy!",
    imgLinkBroccoli: "broccoli3",
    imgLinkCarrot: "carrot5",
  },
];

export const dialogueSequenceEndHealthy = [
  {
    character: "",
    text: "Broccoli smells the yummy food and looks impressed.",
    imgLinkBroccoli: "broccoli1",
    imgLinkCarrot: "carrot8",
  },
  {
    character: "broccoli",
    text: "Whoa… this looks awesome!",
    imgLinkBroccoli: "broccoli3",
    imgLinkCarrot: "carrot5",
  },
  {
    character: "broccoli",
    text: "And it's actually healthy too? WOW! You are the best!!",
    imgLinkBroccoli: "broccoli2",
    imgLinkCarrot: "carrot8",
  },
  {
    character: "carrot",
    text: "Yep! Delicious and healthy. That's how I do it!",
    imgLinkBroccoli: "broccoli3",
    imgLinkCarrot: "carrot5",
  },
  {
    character: "broccoli",
    text: "You crushed it, Chef. This is the best food I have ever seen at a picnic before! I really can't believe it is healthy!",
    imgLinkBroccoli: "broccoli4",
    imgLinkCarrot: "carrot8",
  },
  {
    character: "carrot",
    text: "Now let's dig in. I am really hungry.",
    imgLinkBroccoli: "broccoli4",
    imgLinkCarrot: "carrot5",
  },
];

export const dialogueSequenceEndUnHealthy = [
  {
    character: "",
    text: "Broccoli smells the food.",
    imgLinkBroccoli: "broccoli5",
    imgLinkCarrot: "",
  },
  {
    character: "broccoli",
    text: "This smells really sweet.",
    imgLinkBroccoli: "broccoli6",
    imgLinkCarrot: "carrot6",
  },
  {
    character: "broccoli",
    text: "This must have taken a lot of hard work, but I thought this picnic was going to be healthy.",
    imgLinkBroccoli: "broccoli5",
    imgLinkCarrot: "carrot7",
  },
  {
    character: "carrot",
    text: "I might have gone a little overboard...",
    imgLinkBroccoli: "broccoli6",
    imgLinkCarrot: "carrot6",
  },
  {
    character: "broccoli",
    text: "Maybe we can try again? Let's make something yummy and healthy.",
    imgLinkBroccoli: "broccoli4",
    imgLinkCarrot: "carrot7",
  },
  {
    character: "carrot",
    text: "Alright, this time I will use veggie power! Great idea! Let's give it another go!",
    imgLinkBroccoli: "broccoli3",
    imgLinkCarrot: "carrot6",
  },
];
